import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $nodesOfType } from 'lexical';
import { TemplateVariableNode } from './TemplateVariableNode';

interface UpdateTemplateVariablesPluginProps {
  templateVariables: Record<string, string> | undefined;
}

export function UpdateTemplateVariablesPlugin({
  templateVariables,
}: UpdateTemplateVariablesPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!templateVariables) return;
    editor.update(() => {
      const nodes = $nodesOfType(TemplateVariableNode);
      for (const node of nodes) {
        const key = node.getVariableKey();
        if (key in templateVariables) {
          const newValue = templateVariables[key];
          if (node.getDisplayValue() !== newValue) {
            node.setDisplayValue(newValue);
          }
        }
      }
    });
  }, [editor, templateVariables]);

  return null;
}
